import { axiosNoAuthClient } from '@/shared/apis/config';
import { DtoVerificationType } from '@/shared/constants';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const verifyCodeFormSchema = z.object({
  key: z.string(),
  type: z.nativeEnum(DtoVerificationType),
  code: z.string(),
});
export type VerifyCodeFormType = z.infer<typeof verifyCodeFormSchema>;

export const verifyCodeApi = async (formData: VerifyCodeFormType) => {
  try {
    const response = await axiosNoAuthClient.post(
      '/v1.0/verification/verify-code',
      formData,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useVerifyCodeApi = () => {
  return useMutation({
    mutationFn: verifyCodeApi,
  });
};
